import script from "./CSApplicationsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CSApplicationsTable.vue?vue&type=script&setup=true&lang=js"

import "./CSApplicationsTable.vue?vue&type=style&index=0&id=196fe783&scoped=true&lang=css"
import "./CSApplicationsTable.vue?vue&type=style&index=1&id=196fe783&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-196fe783"]])

export default __exports__